<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getMinFuelGeoJson.data.id"
      :source="getMinFuelGeoJson"
      :layerId="getMinFuelLineLayer.id"
      :layer="getMinFuelLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getMinFuelGeoJson.data.id"
      :source="getMinFuelGeoJson"
      :layerId="getMinFuelPointsLayer.id"
      :layer="getMinFuelPointsLayer"
    />
  </div>
</template>
  
  <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "MinFuelLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "getMinFuelGeoJson",
      "getMinTimeGeoJson",
    ]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getMinFuelLineLayer",
      "getMinFuelPointsLayer",
    ]),
  },
};
</script>